var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 100px"
    }
  }, [_c('file-upload', {
    staticClass: "f-edit",
    attrs: {
      "action": _vm.action,
      "data": {
        resumeId: _vm.rid
      },
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.uploadRemove,
      "fileList": _vm.fileList
    },
    model: {
      value: (_vm.ruleForm.attaches),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "attaches", $$v)
      },
      expression: "ruleForm.attaches"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "f-view"
  }, [_vm._l((_vm.fileList), function(item, index) {
    return (_vm.fileList.length) ? [_c('p', [(item.preUrl) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.preUrl
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "ml-10 mr-10",
      attrs: {
        "href": item.downUrl
      }
    }, [_c('i', {
      staticClass: "el-icon-my-daochu"
    })])])] : _vm._e()
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e2e18f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/attach.vue
// module id = null
// module chunks = 